import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import { ArrowLeft, User, Shield, Clock, Activity, Key, Lock, Mail, MapPin, Briefcase, Smartphone, Calendar } from 'lucide-react';
import { useStore } from '../data/store';
import { toast } from 'sonner';
import { StatusBadge } from '../components/StatusBadge';
export default function UserDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const usersList = useStore(s => s.users);
  const toggleUserStatus = useStore(s => s.toggleUserStatus);
  const resetPassword = useStore(s => s.resetPassword);
  const resetMFA = useStore(s => s.resetMFA);
  const resetDevice = useStore(s => s.resetDevice);
  const user = usersList.find(u => u.id === id);
  if (!user) {
    return <div className="flex flex-col items-center justify-center h-full space-y-4" data-id="element-4050">
        <h2 className="text-xl font-mono text-muted-foreground" data-id="element-4051">
          Pengguna tidak ditemukan
        </h2>
        <Button onClick={() => navigate('/users')} variant="outline" data-id="element-4052">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-4053" /> Kembali ke Daftar
        </Button>
      </div>;
  }
  const handleToggleStatus = () => {
    if (id) {
      toggleUserStatus(id);
      toast.success(`Status pengguna diperbarui.`);
    }
  };
  return <div className="space-y-6 animate-in fade-in duration-500 max-w-4xl mx-auto" data-id="element-4054">
      <div className="flex items-center gap-4 border-b border-border/50 pb-4" data-id="element-4055">
        <Button variant="ghost" size="icon" onClick={() => navigate('/users')} className="hover:bg-primary/20 hover:text-primary" data-id="element-4056">
          <ArrowLeft className="w-5 h-5" data-id="element-4057" />
        </Button>
        <div data-id="element-4058">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground flex items-center gap-3" data-id="element-4059">
            DETAIL PENGGUNA
            <span className="text-sm font-mono text-primary bg-primary/10 px-2 py-1 rounded border border-primary/30" data-id="element-4060">
              {user.id}
            </span>
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-4061">
            Manajemen Akses & Keamanan
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4062">
        <Card className="glass-panel-heavy border-primary/30 shadow-[0_0_30px_rgba(var(--primary),0.1)] md:col-span-1 h-fit" data-id="element-4063">
          <CardHeader className="p-6 border-b border-border/50 bg-primary/5 flex flex-col items-center text-center" data-id="element-4064">
            <div className="w-24 h-24 bg-black/40 border-2 border-border/50 rounded-full flex items-center justify-center mb-4" data-id="element-4065">
              <User className="w-12 h-12 text-muted-foreground" data-id="element-4066" />
            </div>
            <CardTitle className="text-xl font-heading leading-tight" data-id="element-4067">
              {user.name}
            </CardTitle>
            <p className="text-sm font-mono text-muted-foreground mt-2" data-id="element-4068">
              {user.username}
            </p>
            <div className="mt-4" data-id="element-4069">
              <StatusBadge status={user.status === 'Aktif' ? 'Normal' : 'Kritis'} className="text-xs px-3 py-1" data-id="element-4070" />
            </div>
          </CardHeader>
          <CardContent className="p-6 space-y-4" data-id="element-4071">
            <div className="flex justify-between items-center bg-black/20 p-3 rounded border border-border/30" data-id="element-4072">
              <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest flex items-center gap-2" data-id="element-4073">
                <Shield className="w-4 h-4" data-id="element-4074" /> Peran
              </span>
              <span className="font-mono text-sm" data-id="element-4075">{user.role}</span>
            </div>
            <div className="flex justify-between items-center bg-black/20 p-3 rounded border border-border/30" data-id="element-4076">
              <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest flex items-center gap-2" data-id="element-4077">
                <Briefcase className="w-4 h-4" data-id="element-4078" /> Unit
              </span>
              <span className="font-mono text-sm" data-id="element-4079">{user.unit}</span>
            </div>
            <div className="flex justify-between items-center bg-black/20 p-3 rounded border border-border/30" data-id="element-4080">
              <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest flex items-center gap-2" data-id="element-4081">
                <MapPin className="w-4 h-4" data-id="element-4082" /> Wilayah
              </span>
              <span className="font-mono text-sm" data-id="element-4083">{user.region}</span>
            </div>
            <div className="flex justify-between items-center bg-black/20 p-3 rounded border border-border/30" data-id="element-4084">
              <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest flex items-center gap-2" data-id="element-4085">
                <Mail className="w-4 h-4" data-id="element-4086" /> Email
              </span>
              <span className="font-mono text-xs" data-id="element-4087">{user.email}</span>
            </div>
            <div className="flex justify-between items-center bg-black/20 p-3 rounded border border-border/30" data-id="element-4088">
              <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest flex items-center gap-2" data-id="element-4089">
                <Calendar className="w-4 h-4" data-id="element-4090" /> Bergabung
              </span>
              <span className="font-mono text-sm" data-id="element-4091">{user.joined}</span>
            </div>
          </CardContent>
        </Card>

        <div className="md:col-span-2 space-y-6" data-id="element-4092">
          <Card className="glass-panel border-border/50" data-id="element-4093">
            <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-4094">
              <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-4095">
                <Lock className="w-4 h-4 text-primary" data-id="element-4096" /> Keamanan Akun
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6 space-y-6" data-id="element-4097">
              <div data-id="element-4098">
                <p className="text-sm font-medium mb-2" data-id="element-4099">
                  Kata Sandi & Otentikasi
                </p>
                <div className="flex items-center justify-between bg-black/20 p-4 rounded border border-border/30 mb-3" data-id="element-4100">
                  <div className="flex items-center gap-3" data-id="element-4101">
                    <Lock className="w-5 h-5 text-muted-foreground" data-id="element-4102" />
                    <div data-id="element-4103">
                      <p className="text-sm font-mono" data-id="element-4104">Kata Sandi</p>
                      <p className="text-xs text-muted-foreground" data-id="element-4105">
                        Terakhir diubah: 30 hari yang lalu
                      </p>
                    </div>
                  </div>
                  <Button variant="outline" size="sm" onClick={() => {
                  if (id) {
                    resetPassword(id);
                    toast.success('Tautan reset kata sandi telah dikirim.');
                  }
                }} className="font-mono text-xs" data-id="element-4106">
                    Reset Sandi
                  </Button>
                </div>
                <div className="flex items-center justify-between bg-black/20 p-4 rounded border border-border/30" data-id="element-4107">
                  <div className="flex items-center gap-3" data-id="element-4108">
                    <Key className="w-5 h-5 text-[var(--status-active)]" data-id="element-4109" />
                    <div data-id="element-4110">
                      <p className="text-sm font-mono text-[var(--status-active)]" data-id="element-4111">
                        MFA Aktif
                      </p>
                      <p className="text-xs text-muted-foreground" data-id="element-4112">
                        Menggunakan aplikasi authenticator
                      </p>
                    </div>
                  </div>
                  <Button variant="outline" size="sm" onClick={() => {
                  if (id) {
                    resetMFA(id);
                    toast.success('Permintaan reset MFA telah dikirim.');
                  }
                }} className="font-mono text-xs" data-id="element-4113">
                    Reset MFA
                  </Button>
                </div>
              </div>

              <div data-id="element-4114">
                <p className="text-sm font-medium mb-2" data-id="element-4115">Perangkat Terdaftar</p>
                <div className="flex items-center justify-between bg-black/20 p-4 rounded border border-border/30" data-id="element-4116">
                  <div className="flex items-center gap-3" data-id="element-4117">
                    <Smartphone className="w-5 h-5 text-primary" data-id="element-4118" />
                    <div data-id="element-4119">
                      <p className="text-sm font-mono text-primary" data-id="element-4120">
                        {user.device}
                      </p>
                      <p className="text-xs text-muted-foreground" data-id="element-4121">
                        Terminal aman terdaftar
                      </p>
                    </div>
                  </div>
                  <Button variant="outline" size="sm" onClick={() => {
                  if (id) {
                    resetDevice(id);
                    toast.success('Perangkat telah dilepas tautannya.');
                  }
                }} className="font-mono text-xs" data-id="element-4122">
                    Lepas Perangkat
                  </Button>
                </div>
              </div>

              <div data-id="element-4123">
                <p className="text-sm font-medium mb-2" data-id="element-4124">Sesi Aktif</p>
                <div className="bg-black/20 p-4 rounded border border-border/30 space-y-3" data-id="element-4125">
                  <div className="flex justify-between items-center pb-3 border-b border-border/30" data-id="element-4126">
                    <div data-id="element-4127">
                      <p className="text-sm font-mono" data-id="element-4128">
                        192.168.1.45 (Jakarta)
                      </p>
                      <p className="text-xs text-muted-foreground" data-id="element-4129">
                        Chrome - Windows
                      </p>
                    </div>
                    <Badge variant="outline" className="text-[10px] font-mono border-primary text-primary" data-id="element-4130">
                      Saat ini
                    </Badge>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-4131">
                    <div data-id="element-4132">
                      <p className="text-sm font-mono" data-id="element-4133">10.0.0.12 (VPN)</p>
                      <p className="text-xs text-muted-foreground" data-id="element-4134">
                        DENS CAKRA Mobile App
                      </p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={() => toast.success('Sesi jarak jauh telah diakhiri.')} className="text-destructive hover:text-destructive hover:bg-destructive/10 text-xs font-mono" data-id="element-4135">
                      Akhiri Sesi
                    </Button>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="flex gap-4" data-id="element-4136">
            <Button onClick={() => toast.success(`Formulir edit profil ${user.id} dibuka.`)} className="flex-1 bg-primary hover:bg-primary/90 text-primary-foreground font-mono text-xs uppercase tracking-widest py-6" data-id="element-4137">
              Edit Profil
            </Button>
            <Button variant="outline" className="flex-1 font-mono text-xs uppercase tracking-widest border-border/50 py-6" onClick={handleToggleStatus} data-id="element-4138">
              {user.status === 'Aktif' ? 'Nonaktifkan Akun' : 'Aktifkan Akun'}
            </Button>
          </div>
        </div>
      </div>
    </div>;
}